
import PulseButton from '../pulse-button.vue'
import SectionTitle from '../section-title.vue'
import TrackerButtongroup from './tracker-buttongroup.vue'
import TrackerContacts from './tracker-contacts.vue'
import TrackerDelete from './tracker-delete.vue'
import TrackerSegment from './tracker-segment.vue'
import TrackerSlider from './tracker-slider.vue'
import TrackerTextarea from './tracker-textarea.vue'
import {markRaw} from 'vue'
import $companies from 'stores/companies'
import CompanyTile from '../company-tile.vue'
import {$contacts_groups} from 'stores/contacts2'
import {COMPANY_ALERTS, COMPANY_TYPES} from 'consts/tracker'
import {sliderFocus} from '../pulse-defs'


export default {
  components: {
    SectionTitle, TrackerSlider, TrackerButtongroup, TrackerTextarea, PulseButton, TrackerContacts, TrackerSegment, TrackerDelete, CompanyTile
  },
  props: {
    companyId: {type: String, required: true},
    head: {type: Boolean, default: false},
  },
  data() {
    return {
      TYPES: markRaw(COMPANY_TYPES),
      ALERTS: markRaw(COMPANY_ALERTS),
      company: undefined,
      type: undefined
    }
  },
  computed:{
    contacts(){
      if (!this.company?.shared_company_id) return
      return $contacts_groups.getContacts(this.company.shared_company_id)
    },
    loading() {
      return this.company == undefined
    },
    saving() {
      return this.company?.saving
    },
    tracker_focus: {
      // for sliderFocus
      get() {
        return this.company.tracker_focus
      },
      set(val) {
        this.company.tracker_focus = val
      }
    },
    slider_focus: sliderFocus(),
    focus_text() {
      return !!this.company?.focus_on?.trim()
    },
    can_save() {
      return this.company.changed
    }
  },
  mounted(){
    this.$debounce_175(this.init)
  },
  beforeUnmount() {
    $contacts_groups.abortAll()
    $companies.abortAll()
  },
  methods: {
    async init(){
      const company = await $companies.loadCompany(this.companyId)

      this.type = company.tracker_type

      await $contacts_groups.load(
        {
          shared_company_id: company.shared_company_id,
          company_id: this.companyId
        }
      )

      this.company = company
    },
    openDeleteModal() {
      this.$refs.delete.open(this.company)
    },
    async onSave(){
      await this.company.save()
      this.type = this.company.tracker_type
      this.$dispatch('save', this.company)
    },
    trackPerson(){
      this.$dispatch('track-person', {company_id: this.companyId, from: true})
    },
    editPerson(contact_id){
      this.$dispatch('edit-person', {contact_id, company_id: this.companyId, from: true})
    }
  }
}
